module.exports = __webpack_public_path__ + "static/flags/KZ-aed854a51bcd91467ba40a34014c96bb.gif";